import { createSlice } from "@reduxjs/toolkit";

export const listAdminShort = createSlice({
  name: "listAdminShort",
  initialState: {
    value: false,
  },
  reducers: {
    setListAdminShort: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setListAdminShort } = listAdminShort.actions;
export default listAdminShort.reducer;
